import { type EvidenceDetail, getApiEvidenceV1EvidenceSessionRetrieveQueryKey, useQueryClient } from 'api';
import { useTranslation } from 'i18n';
import React from 'react';
import { Dialog, DialogActions, DialogCloseButton, DialogContent, DialogTitle, Stack, Typography } from 'ui';

import { EvidenceEditForm } from '../EvidenceEditForm/EvidenceEditForm';
import { EvidenceGrid } from '../EvidenceGrid/EvidenceGrid';

export interface Props {
  open: boolean;
  onClose: () => void;
  date: string;
  uploadedById: number | null;
  parentContentTypeId: number;
  parentId: number;
}

export const SessionEvidenceEditDialog = ({
  onClose,
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
  open,
}: Props) => {
  const { t } = useTranslation('features');
  const queryClient = useQueryClient();
  const [selectedEvidenceIds, setSelectedEvidenceIds] = React.useState<EvidenceDetail['id'][]>([]);

  const handleClose = () => {
    setSelectedEvidenceIds([]);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>{t('backlog.evidence.sessionEvidenceEditDialog.step1Title')}</DialogTitle>
      <DialogCloseButton onClick={handleClose} />
      <DialogContent>
        <EvidenceGrid
          setSelectedEvidenceIds={setSelectedEvidenceIds}
          date={date}
          parentContentTypeId={parentContentTypeId}
          parentId={parentId}
          uploadedById={uploadedById}
        />
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
        }}
      >
        <Stack
          direction="column"
          sx={{
            width: '100%',
          }}
        >
          <Typography variant="h6">{t('backlog.evidence.sessionEvidenceEditDialog.step2Title')}</Typography>
          <EvidenceEditForm
            deleteMode="site-material"
            deleteParentId={parentId}
            selectedEvidenceIds={selectedEvidenceIds}
            onSuccess={() => {
              queryClient.invalidateQueries({
                queryKey: getApiEvidenceV1EvidenceSessionRetrieveQueryKey({
                  date,
                  parent_content_type_id: parentContentTypeId,
                  parent_id: parentId,
                  uploaded_by: uploadedById,
                }),
              });

              onClose();
            }}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
